<template>
  <div>
    <v-card v-if="order" class="py-3 px-3 mb-3">
      <div class="d-flex align-center justify-space-between mb-3">
        <h4 class="text-uppercase">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.address') }}
        </h4>
      </div>

      <div>
        {{ order.address }}
      </div>
    </v-card>

    <v-card v-if="hasBillingAddressData" class="py-3 px-3 mb-3">
      <div class="d-flex align-center justify-space-between mb-3">
        <h4 class="text-uppercase">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.billingAddress') }}
        </h4>
      </div>

      <div v-if="billingAddressLine">
        {{ billingAddressLine }}
      </div>
      <div v-if="billingCompanyLine">
        {{ billingCompanyLine }}
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default: null,
    },
  },
  computed: {
    billingAddressLine() {
      const ba = this.order && this.order.billingAddress;
      if (!ba) return '';
      return [ba.street, ba.post_code, ba.city, ba.country_id].filter(Boolean).join(', ');
    },
    billingCompanyLine() {
      const ba = this.order && this.order.billingAddress;
      if (!ba) return '';
      return [ba.company_name, ba.company_identification_number, ba.company_vat_number].filter(Boolean).join(', ');
    },
    hasBillingAddressData() {
      return Boolean(this.billingAddressLine || this.billingCompanyLine);
    },
  },
};
</script>
